import { ShieldCheck, CheckCircle2 } from 'lucide-react';
import { useStore } from '@/store/useStore';
import { t } from '@/i18n/translations';

export default function Footer() {
  const { settings } = useStore();
  const lang = settings.language;

  const footerText = {
    nl: 'door',
    fr: 'par',
    en: 'by',
  };

  return (
    <footer className="fixed bottom-0 left-0 right-0 z-50 px-4 py-2 text-center bg-white/90 backdrop-blur-md border-t border-gray-200/50 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
      <p className="text-xs text-gray-600 flex items-center justify-center gap-1 whitespace-nowrap">
        <CheckCircle2 className="w-3.5 h-3.5 text-primary-500" />
        <span className="font-medium"><span className="text-primary-500">Easy</span>Habits</span>
        {footerText[lang]}{' '}
        <a
          href="https://easycyberprotection.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 text-primary-600 hover:text-primary-700 font-medium"
        >
          <ShieldCheck className="w-3.5 h-3.5" />
          Easy Cyber Protection
        </a>
      </p>
    </footer>
  );
}
